function cov_2bx45axik4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/EmailFilled.tsx";
  var hash = "acfe1d7fef52f844869267ac7709624c4a3a8ce3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/EmailFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "acfe1d7fef52f844869267ac7709624c4a3a8ce3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2bx45axik4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2bx45axik4();
var Icon = (cov_2bx45axik4().s[0]++, {
  name: 'email-filled',
  svg: "<path d=\"M22 10.2507V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V10.2507C2.08278 10.361 2.18537 10.4594 2.30664 10.5402L10.7519 16.1704C11.5077 16.6742 12.4923 16.6742 13.2481 16.1704L21.6934 10.5402C21.8146 10.4594 21.9172 10.361 22 10.2507Z\" fill=\"currentColor\"/>\n  <path d=\"M20.9312 8.25183L12.5735 2.40143C12.2291 2.1604 11.7709 2.1604 11.4265 2.40143L3.06881 8.25183C3.28473 8.26353 3.50044 8.33144 3.69339 8.46007L12 13.9978L20.3066 8.46007C20.4996 8.33144 20.7153 8.26353 20.9312 8.25183Z\" fill=\"currentColor\"/>"
});
export default Icon;